var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.76 21.221c.19 0 .38-.07.53-.22l3.49-3.47a.75.75 0 000-1.06l-3.49-3.47a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06l2.95 2.94-2.95 2.94c-.29.29-.29.77 0 1.06.14.15.33.22.53.22z","opacity":".75","key":0}),React.createElement("path",{"d":"M18.76 21.221c.19 0 .38-.07.53-.22l3.49-3.47a.75.75 0 000-1.06l-3.49-3.47a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06l2.95 2.94-2.95 2.94c-.29.29-.29.77 0 1.06.14.15.33.22.53.22z","key":1})]);
}

ArrowRight.defaultProps = {"viewBox":"0 0 34 34","preserveAspectRatio":"xMidYMid meet"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
